var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99988 6.75C2.99988 6.55109 3.0789 6.36032 3.21955 6.21967C3.3602 6.07902 3.55097 6 3.74988 6H20.2499C20.4488 6 20.6396 6.07902 20.7802 6.21967C20.9209 6.36032 20.9999 6.55109 20.9999 6.75C20.9999 6.94891 20.9209 7.13968 20.7802 7.28033C20.6396 7.42098 20.4488 7.5 20.2499 7.5H3.74988C3.55097 7.5 3.3602 7.42098 3.21955 7.28033C3.0789 7.13968 2.99988 6.94891 2.99988 6.75ZM2.99988 12C2.99988 11.8011 3.0789 11.6103 3.21955 11.4697C3.3602 11.329 3.55097 11.25 3.74988 11.25H20.2499C20.4488 11.25 20.6396 11.329 20.7802 11.4697C20.9209 11.6103 20.9999 11.8011 20.9999 12C20.9999 12.1989 20.9209 12.3897 20.7802 12.5303C20.6396 12.671 20.4488 12.75 20.2499 12.75H3.74988C3.55097 12.75 3.3602 12.671 3.21955 12.5303C3.0789 12.3897 2.99988 12.1989 2.99988 12ZM2.99988 17.25C2.99988 17.0511 3.0789 16.8603 3.21955 16.7197C3.3602 16.579 3.55097 16.5 3.74988 16.5H20.2499C20.4488 16.5 20.6396 16.579 20.7802 16.7197C20.9209 16.8603 20.9999 17.0511 20.9999 17.25C20.9999 17.4489 20.9209 17.6397 20.7802 17.7803C20.6396 17.921 20.4488 18 20.2499 18H3.74988C3.55097 18 3.3602 17.921 3.21955 17.7803C3.0789 17.6397 2.99988 17.4489 2.99988 17.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListicon);
export default __webpack_public_path__ + "static/media/listicon.369d61b7568a004f65e7ed9896596770.svg";
export { ForwardRef as ReactComponent };